// React
import React from 'react';

// Next
import Head from 'next/head';

// Interfaces
import {MetaTag} from "interfaces/metaTag";

interface MetaTagsProps {
    metaTags: MetaTag[];
}

const MetaTags: React.FC<MetaTagsProps> = ({metaTags}) => {
    return (
        <>
            <Head>
                {metaTags.map((meta, index) => {
                    const metaProps = Object.fromEntries(
                        Object.entries(meta).filter(([_, value]) => value !== undefined && value !== null)
                    );

                    return <meta key={index} {...metaProps} />;
                })}
            </Head>
        </>
    );
};

export default MetaTags;
